import type { ApartmentChannelMapping, Provider } from '@/lib/channels';
import { AirbnbConnect } from './AirbnbConnect';
import { BookingComConnect } from './BookingComConnect';
import { BookingEngineCard } from './BookingEngineCard';

interface Props {
  apartmentID: string;
  provider: Provider;
  mapping: ApartmentChannelMapping | undefined;
  canWrite: boolean;
}

export function ConnectionTab({ apartmentID, provider, mapping, canWrite }: Props) {
  if (provider === 'booking_com') {
    return <BookingComConnect apartmentID={apartmentID} mapping={mapping} canWrite={canWrite} />;
  }

  if (provider === 'airbnb') {
    return <AirbnbConnect apartmentID={apartmentID} mapping={mapping} canWrite={canWrite} />;
  }

  if (provider === 'booking_engine') {
    return <BookingEngineCard apartmentID={apartmentID} mapping={mapping} canWrite={canWrite} />;
  }

  return null;
}
